import Vue from 'vue'
import Vuex from 'vuex'
import http from './axios'
import router from './router'
import _ from 'lodash'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    authorization: {
      access_token: localStorage.getItem('token') ? localStorage.getItem('token') : null,
      expires_in: null
    },
    messages: [],
    userTasks: [],
    userActions: [],
    brandLogoUrl: '',
    userPoints: 0,
    userCoins: 0,
    userLevel: 0,
    spinnerVisible: false,
    userRemoveRequestedAt: null,
    unavailableUserState: false,
    pendingConfirmation: null,
    missingProfileFields: []
  },
  actions: {
    logout({ context }) {
      http
        .get(
          "/api/v1/campaigns/" + this.state.campaign.id + "/users/logout"
        ).finally(response => {
          localStorage.removeItem('token')
          this.state.authorization.access_token = null;
          delete http.defaults.headers.common['Authorization']
          router.push('/')
          this.commit("hideSpinner");
          this.commit("updateUser",  {});
          this.commit('updateUserRemoveRequestedAt', null);
        })
    },
    async getUserInfo({ context }) {
      if(this.state.campaign !== undefined) {
        let response = await http.get("/api/v1/campaigns/" + this.state.campaign.id + "/users/info");
        let user = _.get(response, 'data.data.user');
        this.commit('updateUser', user);
        this.state.unavailableUserState = false;
        this.commit('updateUserPoints', _.get(user, 'points', 0));
        this.commit('updateUserCoins', _.get(user, 'coins', 0));
        this.commit('updateUserLevel', _.get(user, 'level', 1));
        this.commit('updateUserRemoveRequestedAt', _.get(user, 'remove_requested_at', null));
        
      }
    },
    async getUserTasks({ context }) {
      let response = await http.get("/api/v1/campaigns/" + this.state.campaign.id + "/users/tasks");
      this.commit('updateUserTasks', _.get(response, 'data.data.tasks', []))
    },
    async getUnreadMessages({ context }) {
      let response = await http.get("/api/v1/campaigns/" + this.state.campaign.id + "/users/messages/unread");
      this.commit('updateMessages', _.get(response, 'data.data.messages', []));


      _.forEach(this.state.messages, (message) => {
        let messagePoints = _.get(message, 'points', '');
        if (messagePoints.length > 0) {
          this.dispatch('getUserInfo');
          return false;
        }
      });
    },
    async getUserActions({ context }) {
      let response = await http.get("/api/v1/campaigns/" + this.state.campaign.id + '/users/tasks/done')
      this.commit('updateUserActions', _.get(response, 'data.data.done', []));
    }
  },
  mutations: {
    unshiftMessage(state, message) {
      state.messages.unshift(message);
    },
    pushMessage(state, message) {
      state.messages.push(message);
    },
    dismissMessage(state) {
      state.messages.pop();
    },
    updateUser(state, userInfo) {
      state.user = userInfo;
    },
    updateUserPoints(state, points) {
      state.userPoints = points;
    },
    updateUserCoins(state, coins) {
      state.userCoins = coins;
    },
    updateUserLevel(state, level) {
      if(state.userLevel !== undefined && state.userLevel !== 0 && level !== state.userLevel) {
        this.commit("unshiftMessage", {
          type: "success",
          title: "Congratulazioni!",
          text: "Hai raggiunto il livello "+ level
        });
      }
      state.userLevel = level;
    },
    updateUserTasks(state, tasks) {
      state.userTasks = tasks
    },
    updateUserActions(state, actions) {
      state.userActions = actions
    },
    updateMessages(state, messages) {
      state.messages = messages;
    },
    updateBrand(state, brand) {

    },
    updateBrandLogo(state, brandLogoUrl) {
      state.brandLogoUrl = brandLogoUrl;
    },
    showSpinner(state) {
      state.spinnerVisible = true;
    },
    hideSpinner(state) {
      state.spinnerVisible = false;
    },
    updateUserRemoveRequestedAt(state, requestedAt) {
      state.userRemoveRequestedAt = requestedAt;
    },
    updateMissingProfileFields(state, missingFields) {
      state.missingProfileFields = missingFields
    },
    updatePendingConfirmation(state, pendingConfirmation) {
      state.pendingConfirmation = pendingConfirmation
    }
  },
  getters: {
    isLoggedIn: state => !!state.authorization.access_token,
    getUserPoints: state => state.userPoints,
    getUserCoins: state => state.userCoins,
    getUserLevel: state => state.userLevel,
    getUserTasks: state => state.userTasks,
    getUserActions: state => state.userActions,
    getBrandLogo: state => _.get(state, 'brand.logo', ''),
    isSpinnervisible: state => state.spinnerVisible,
    getUserRemoveRequestedAt: state => state.userRemoveRequestedAt,
    getMissingProfileFields: state => state.missingProfileFields,
    getPendingConfirmation: state => state.pendingConfirmation
  }
})